import { createContext, useEffect, useState } from "react";
import axios from "axios";

import { buildApiUrl } from "../services/api";

const NegosContext = createContext({
  negos: [],
  setNegos: () => {},
  loading: true,
});

export const NegosProvider = ({ children }) => {
  const [negos, setNegos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const fetchNegos = async () => {
      try {
        const response = await axios.get(buildApiUrl("/server/api/contacts/negolist"));

        if (!isCancelled && response.data?.negosList) {
          setNegos(response.data.negosList);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des negociateurs:", error);
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    fetchNegos();

    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <NegosContext.Provider value={{ negos, setNegos, loading }}>
      {children}
    </NegosContext.Provider>
  );
};

export default NegosContext;
